var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7194 11.9107C27.394 11.5853 26.8663 11.5853 26.5409 11.9107L25.8139 12.6377C24.8847 12.1938 23.7379 12.3567 22.9682 13.1264L14.1294 21.9652L18.8435 26.6792L27.6823 17.8404C28.452 17.0707 28.6149 15.924 28.171 14.9947L28.8979 14.2678C29.2234 13.9423 29.2234 13.4147 28.8979 13.0892L27.7194 11.9107ZM24.1627 19.0029L18.8435 24.3222L16.4864 21.9652L21.8057 16.6459L24.1627 19.0029ZM25.678 17.4877L26.5038 16.6619C26.8292 16.3365 26.8292 15.8088 26.5038 15.4834L25.3253 14.3049C24.9998 13.9794 24.4722 13.9794 24.1468 14.3049L23.321 15.1307L25.678 17.4877Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 29.1252L13.4346 22.643L18.1483 27.3574L11.6665 29.1252Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditListIcon);
export default __webpack_public_path__ + "static/media/editListIcon.cacbe4eb2ead51ff887ddf02aec9695b.svg";
export { ForwardRef as ReactComponent };